import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import ChatBot from '../common/ChatBot';
import { theme } from '../../theme';
import { hrms } from '../../services/api';

function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [announcementCount, setAnnouncementCount] = useState(0);

  useEffect(() => {
    hrms.getAnnouncements().then(r => {
      const items = Array.isArray(r.data) ? r.data : (r.data?.items || []);
      const unread = items.filter(a => !a.is_read).length;
      setAnnouncementCount(unread || items.length);
    }).catch(() => {});
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* Navbar */}
      <Navbar user={user} onLogout={handleLogout} announcementCount={announcementCount} />

      {/* Body */}
      <div style={{ display: 'flex', flex: 1, marginTop: '64px', overflow: 'hidden' }}>
        {/* Sidebar */}
        <Sidebar
          user={user}
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        />

        {/* Main Content */}
        <main
          style={{
            flex: 1,
            overflowY: 'auto',
            background: theme.pageBg,
            padding: '2rem',
            minWidth: 0,
          }}
        >
          {/* Toggle button */}
          <button
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            style={{
              position: 'fixed',
              left: sidebarCollapsed ? '1rem' : '255px',
              top: '76px',
              background: theme.white,
              border: `1px solid ${theme.border}`,
              borderRadius: '50%',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.8rem',
              zIndex: 50,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              transition: 'left 0.25s ease',
            }}
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed ? '›' : '‹'}
          </button>

          {children}
        </main>
      </div>
      <ChatBot />
    </div>
  );
}

export default Layout;
